<template>
    <div class="flex-fill flex-column">
        <div class="flex-shrink-1">
            <div class="headline">NLF Agent Query Logs</div>
            <div class="mb-4 caption" style="color: #C0C3CF; font-size: 14px;">
                Browse all NLF agent query logs. Each row represents a single user request, summarizing token usage, cost, and processing time. Click the detail icon to view the full execution trace.
            </div>
        </div>

        <fe-grid
            ref="grid"
            :rowData="items"
            :columnDefs="headerColumnDefs"
            style="height: 100%"
            :showAddRowBtn="false"
            displayDensity="small"
            disableInlineCreate
        >
            <template #toolbar-items>
                <fe-tooltip tooltip="Reload Table Data" direction="top">
                    <fe-icon-btn
                        class="theme--light"
                        usage="ghost"
                        useIcon="fas fa-sync-alt"
                        aria-label="Reload table data"
                        data-test="nlf-logs-reload-btn"
                        @click="loadData"
                        style="margin-top: -4px"
                    />
                </fe-tooltip>
            </template>
        </fe-grid>
    </div>
</template>

<script>
    import nlfLogsMixin from './nlfLogsMixin'

    export default {
        name: 'NlfLogsRequestList',
        mixins: [nlfLogsMixin],
        data() {
            let me = this
            return {
                items: [],
                headerColumnDefs: [{
                    headerName: 'Details',
                    maxWidth: 70,
                    editable: false,
                    sortable: false,
                    suppressMovable: true,
                    cellRenderer() {
                        return '<i class="fe-grid-icon fal fa-search theme--light" style="font-size:12px; cursor:pointer;" role="img" aria-label="View details"></i>'
                    },
                    onCellClicked(v) {
                        me.$emit('show-details', v.data)
                    }
                }, {
                    headerName: 'User',
                    field: 'user_name',
                    editable: false,
                    maxWidth: 160,
                    suppressMovable: true
                }, {
                    headerName: 'Title',
                    field: 'user_title',
                    editable: false,
                    maxWidth: 160,
                    suppressMovable: true
                }, {
                    headerName: 'Initial Request',
                    field: 'request',
                    editable: false,
                    flex: 2,
                    suppressMovable: true,
                    valueGetter(v) {
                        return v.data.request?.query || ''
                    }
                }, {
                    headerName: 'Feedback',
                    field: 'rating',
                    colId: 'feedback',
                    editable: false,
                    maxWidth: 120,
                    suppressMovable: true,
                    cellRenderer(v) {
                        return me.renderFeedbackCell(v.value, 'nlf-logs-feedback-cell')
                    }
                }, {
                    headerName: 'Feedback Comments',
                    field: 'feedback_text',
                    colId: 'feedback_comments',
                    editable: false,
                    flex: 1,
                    suppressMovable: true,
                    cellRenderer(v) {
                        return me.renderFeedbackCell(v.value, 'nlf-logs-feedback-comments-cell')
                    }
                }, {
                    headerName: 'Input Tokens',
                    field: 'total_input_tokens',
                    editable: false,
                    maxWidth: 120,
                    suppressMovable: true,
                    cellStyle: { textAlign: 'right' },
                    valueFormatter(v) {
                        return v.value != null ? Number(v.value).toLocaleString() : 'n/a'
                    }
                }, {
                    headerName: 'Output Tokens',
                    field: 'total_output_tokens',
                    editable: false,
                    maxWidth: 130,
                    suppressMovable: true,
                    cellStyle: { textAlign: 'right' },
                    valueFormatter(v) {
                        return v.value != null ? Number(v.value).toLocaleString() : 'n/a'
                    }
                }, {
                    headerName: 'Cost',
                    field: 'total_cost',
                    editable: false,
                    maxWidth: 90,
                    suppressMovable: true,
                    cellStyle: { textAlign: 'right' },
                    valueFormatter(v) {
                        return v.value ? '$' + (Number(v.value) || 0).toFixed(4) : 'n/a'
                    }
                }, {
                    headerName: 'Duration (ms)',
                    field: 'total_duration_ms',
                    editable: false,
                    maxWidth: 130,
                    suppressMovable: true,
                    cellStyle: { textAlign: 'right' },
                    valueFormatter(v) {
                        return v.value != null ? Number(v.value).toLocaleString() : 'n/a'
                    }
                }, {
                    headerName: 'Created At',
                    field: 'created_at',
                    editable: false,
                    maxWidth: 160,
                    suppressMovable: true
                }]
            }
        },
        mounted() {
            this.loadData()
        },
        methods: {
            renderFeedbackCell(value, testId) {
                // Return a DOM node (not an HTML string) so user-provided feedback text
                // is set via textContent and cannot inject markup.
                let span = document.createElement('span')
                span.setAttribute('data-test', testId)
                span.textContent = value || 'none'
                return span
            },
            loadData() {
                this.$modelGet('nlfLogRequest')
                    .then(data => {
                        this.items = data
                    })
                    .catch(err => {
                        console.error('Failed to load NLF query logs:', err)
                    })
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>
